export default {
    loadingUnityTypeFiles(state) {
        state.loading = true;
    },
    successUnityTypeFiles(state, files) {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.data = files;
    },
    errorUnityTypeFiles(state, error) {
        state.loading = false;
        state.success = false;
        state.error = error;
        state.data = [];
    },
    resetSuccessUnityTypeFiles(state) {
        state.success = false;
    },
};
